// src/hooks/useDesignerStats.js
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setDesignerStats, setError, clearDesignerStats } from '../features/designerStatsSlice';

const API_URL = 'https://api-4h4srbodqa-uc.a.run.app/api';
// const API_URL = 'http://localhost:4000';

export const useDesignerStats = (designerId) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['designerStats', designerId],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/designers/${designerId}`);
      console.log('Raw API response:', data); // Log the raw API response
      return data;
    },
    onSuccess: (data) => {
      console.log('Setting designer stats in Redux:', data);
      dispatch(setDesignerStats(data));
    },
    onError: (error) => {
      console.error('Fetch error:', error);
      dispatch(setError(error.message));
    },
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};